import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const workShiftListService = (params: Types.WorkShiftListRequest) =>
  RestAPIClient.call<Types.WorkShiftListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const workShiftListShortService = (params: Types.WorkShiftListRequest) =>
  RestAPIClient.call<Types.WorkShiftListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const workShiftListPAShortService = (
  params: Types.WorkShiftListRequest
) =>
  RestAPIClient.call<Types.WorkShiftListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShortPA,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const workShiftDetailService = (id: string) =>
  RestAPIClient.call<Types.WorkShift>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const workShiftCreateService = (params: Types.WorkShiftCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const workShiftUpdateService = (params: Types.WorkShiftUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const workShiftDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
